<template>
  <CustomPage title="商品清单" style="background: #f7f7f7">
    <div slot="content" class="goodsdetail-container">
      <div class="body">
        <div
          class="panel"
          :class="{ 'van-hairline--buttom': index }"
          v-for="(item, index) in list"
          :key="item.orderItemId"
          @click="jumpToGoodsDetail(item)"
        >
          <div class="img">
            <img
              :style="{
                backgroundImage: 'url(' + item.imgUrl + ')',
              }"
            />
          </div>
          <div class="value">
            <div class="title van-ellipsis">
              {{ item.goodInfoName }}
            </div>
            <div class="spec">
              {{ item.spec === '' ? '默认规格' : item.spec }}
            </div>
            <div class="amount-num">
              <div class="amount">¥{{ item.actPrice }}</div>
              <div class="num">x{{ item.qty }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from '@/components/custom-page.vue'
export default {
  components: { CustomPage },
  data() {
    return {
      list: [],
    }
  },
  created() {
    this.list = JSON.parse(this.$route.query.data)
  },
  methods: {
    jumpToGoodsDetail(item) {
      //跳转到商品详情


      this.$router.push({
        name: 'TopListGoodsDetail',
        params: { id: item.actSpuId },
        query: { oldPage: 'orderCenterGoodsList' },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.goodsdetail-container {
  padding: 26px 24px;
  .body {
    background-color: #fff;
    box-shadow: 0px 4px 12px 0px rgba(153, 153, 153, 0.1);
    border-radius: 12px;
    padding-left: 28px;
    .panel {
      display: flex;
      padding: 40px 28px 40px 0;
      .img {
        img {
          width: 168px;
          height: 168px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
        }
      }
      .value {
        flex: 1;
        min-width: 0;
        padding-left: 20px;
        .title {
          font-size: 28px;
          line-height: 28px;
          padding-top: 6px;
        }
        .spec {
          display: inline-block;
          background: #f8f8f8;
          border-radius: 4px;
          font-size: 24px;
          font-weight: 400;
          color: #4f505b;
          line-height: 24px;
          padding: 11px 14px;
          margin-top: 8px;
        }
        .amount-num {
          padding-top: 52px;
          display: flex;
          justify-content: space-between;
          .amount {
            font-size: 28px;
            font-weight: 800;
            color: #e82237;
            line-height: 28px;
          }
          .num {
            font-size: 28px;
            font-weight: 400;
            color: #999999;
            line-height: 28px;
          }
        }
      }
    }
  }
}
</style>
